const PLATFORM_TYPE = {
  KRPC: 'krpc',
  JPPC: 'jppc',
  ARENA: 'arena',
}

export {
  PLATFORM_TYPE,
}

export default {
  WEB_TOKEN_DOMAIN: 'nexon.com',
  WEB_TOKEN_KEY: '_ifwt',
  GUEST_WEB_TOKEN_KEY: '_ifwt_guest',
  WEB_SSO_SESSION_KEY: '_ifwt_sso',
  PLATFORM_KEY: '_ifplatform',
  PLATFORM_SELECTOR_KEY: '_ifplatform_selector',
  GID_KEY: '_ifgid',
  CID_KEY: '_ifcid',
  WEB_SSO_INSIGN_PATH: '/insign',
  LOCALE_KEY: '_iflocale'
}
